import { render, staticRenderFns } from "./LmCaratulatorsPrivileges.vue?vue&type=template&id=5df59bb6&"
import script from "./LmCaratulatorsPrivileges.vue?vue&type=script&lang=js&"
export * from "./LmCaratulatorsPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports